import { oneliveAssets } from './assets';

export interface OneliveGnbMenuItem {
  label: string;
  path: string;
  icon: string;
}

export const ONELIVE_GNB_MENU: OneliveGnbMenuItem[] = [
  { label: 'TOP 랭킹', path: '/ranking', icon: oneliveAssets.rank },
  { label: 'LIVE NOW', path: '/live', icon: oneliveAssets.vod },
  { label: '채팅방', path: '/chat', icon: oneliveAssets.chat },
  { label: '공지사항', path: '/board/notice', icon: oneliveAssets.notice },
  { label: '자주하는질문', path: '/faq', icon: oneliveAssets.event },
];

/** 모바일 햄버거 메뉴 (twolivetv 참고) */
export const ONELIVE_MOBILE_GNB_MENU: OneliveGnbMenuItem[] = [
  { label: 'LIVE', path: '/live', icon: oneliveAssets.vod },
  { label: 'TOP랭킹', path: '/ranking', icon: oneliveAssets.rank },
  { label: '채팅리스트', path: '/chat', icon: oneliveAssets.chat },
  { label: '공지사항', path: '/board/notice', icon: oneliveAssets.notice },
  { label: '자주하는질문', path: '/faq', icon: oneliveAssets.event },
];
